import Link from 'next/link'
import clsx from 'clsx'

const baseStyles = {
  solid:
    'group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2',
  outline:
    'group inline-flex ring-1 items-center justify-center rounded-full py-2 px-4 text-sm',
}

const variantStyles = {
  solid: {
    slate: 'bg-dark text-white hover:bg-primary hover:text-white active:bg-mid active:text-white focus-visible:outline-dark',
    blue: 'bg-primary text-primary-foreground hover:text-primary-foreground hover:bg-mid active:bg-dark active:text-primary-foreground focus-visible:outline-primary',
    white: 'bg-white text-dark hover:bg-light/20 active:bg-primary/20 active:text-dark focus-visible:outline-white',
  },
  outline: {
    slate:
      'ring-dark/40 text-dark/90 hover:text-dark hover:ring-dark/60 active:bg-light/10 active:text-dark focus-visible:outline-primary focus-visible:ring-dark/60',
    white:
      'ring-white/60 text-white hover:ring-white/80 active:ring-white focus-visible:outline-white',
  },
}

export function Button({ className, ...props }) {
  const { variant = 'solid', color = 'slate', href, ...rest } = props
  const classNameStyles = clsx(
    baseStyles[variant],
    variant === 'outline'
      ? variantStyles.outline[color]
      : variant === 'solid'
        ? variantStyles.solid[color]
        : undefined,
    className,
  )

  if (!href) {
    return <button className={classNameStyles} {...rest} />
  }

  return <Link className={classNameStyles} href={href} {...rest} />
}
